import React from "react";
import styled from "styled-components";
import {DateTime} from "luxon";

const StyledTimerFrame = styled.div`
    float: right;
    height: 100%;
    color: #C9C9C9;
    font-size: 18px;
    padding: 21px;
    box-sizing: border-box;
    .stream-time{
        color: white;
    }
`;

interface IVideoTimer {
    className?: string,
    currentTime: number,
    duration: number
}

const VideoTimer: React.FC<IVideoTimer> = (({
                                                className,
                                                currentTime,
                                                duration
                                            }) => {

    const dateTimeSecondsToFormat = (s: number) => {
        if (isNaN(s) || s === Infinity) {
            s = 0;
        }
        return DateTime.fromSeconds(s).toFormat('mm:ss');
    };

    return (
        <StyledTimerFrame className={className}>
            <span className={"stream-time"}>{dateTimeSecondsToFormat(currentTime)}</span>
            /
            <span className={"all-time"}>{dateTimeSecondsToFormat(duration)}</span>
        </StyledTimerFrame>
    )
});

export default VideoTimer;